import { createReducer } from 'typesafe-actions';
import {
  INIT_CHATROOM_ID,
  UPDATE_CHATROOM_ID,
  INIT_PREVIOUS_PATH,
  UPDATE_PREVIOUS_PATH,
  INIT_SELECTED_RFQ_ID,
  UPDATE_SELECTED_RFQ_ID,
  INIT_SELECTED_CHATROOM_ID,
  UPDATE_SELECTED_CHATROOM_ID,
  INIT_SIDE_MENU,
  UPDATE_SIDE_MENU,
  INIT_QUOTATION_SELECTED,
  UPDATE_SELECTED_QUOTATION,
  INIT_DASHBOARD,
  INIT_DISABLED_SIDE_MENU,
  UPDATE_DISABLED_SIDE_MENU,
  UPDATE_SELECTED_QUOTATION_TYPE
} from './actions';
import { IDashboardState, DashboardAction } from './types';

const initialState: IDashboardState = { selectedRfqId: '' };

export const dashboard = createReducer<IDashboardState, DashboardAction>(
  initialState,
  {
    [INIT_DASHBOARD]: () => {
      return initialState;
    },
    [INIT_CHATROOM_ID]: (state) => {
      return {
        ...state,
        chatRoomId: ''
      };
    },
    [UPDATE_CHATROOM_ID]: (state, action) => {
      return {
        ...state,
        chatRoomId: action.payload
      };
    },
    [INIT_PREVIOUS_PATH]: (state) => {
      return {
        ...state,
        previousPath: ''
      };
    },
    [UPDATE_PREVIOUS_PATH]: (state, action) => {
      return {
        ...state,
        previousPath: action.payload
      };
    },
    [INIT_SELECTED_RFQ_ID]: (state) => {
      return {
        ...state,
        selectedRfqId: ''
      };
    },
    [UPDATE_SELECTED_RFQ_ID]: (state, action) => {
      return {
        ...state,
        selectedQuotationId: undefined,
        selectedRfqId: action.payload
      };
    },
    [INIT_SELECTED_CHATROOM_ID]: (state) => {
      return {
        ...state,
        selectedChatRoomId: undefined
      };
    },
    [UPDATE_SELECTED_CHATROOM_ID]: (state, action) => {
      return {
        ...state,
        selectedQuotationId: undefined,
        selectedChatRoomId: action.payload
      };
    },
    [INIT_SIDE_MENU]: (state) => {
      return {
        ...state,
        selectedSideMenu: undefined
      };
    },
    [UPDATE_SIDE_MENU]: (state, action) => {
      return {
        ...state,
        selectedSideMenu: action.payload
      };
    },
    [INIT_DISABLED_SIDE_MENU]: (state) => {
      return {
        ...state,
        disabledSideMenu: undefined
      };
    },
    [UPDATE_DISABLED_SIDE_MENU]: (state, action) => {
      return {
        ...state,
        disabledSideMenu: [...action.payload]
      };
    },
    [INIT_QUOTATION_SELECTED]: (state) => {
      return {
        ...state,
        selectedQuotationId: undefined
      };
    },
    [UPDATE_SELECTED_QUOTATION]: (state, action) => {
      return {
        ...state,
        selectedQuotationId: {
          ...action.payload
        }
      };
    },
    [UPDATE_SELECTED_QUOTATION_TYPE]: (state, action) => {
      return {
        ...state,
        selectedQuotationId: {
          partnerId: undefined,
          quotationId: undefined,
          rfqId: undefined,
          quotationType: 'REQUEST'
        }
      };
    }
  }
);
